import Component from '@glimmer/component';

/**
 * @param {Number}  number
 */
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class CircleNumber extends Component {}
